var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFriendsTalking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 762.87 489.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daedfb;}.cls-2{fill:#b4dffe;}.cls-3{fill:#64b1e8;}.cls-4{fill:#fff;}.cls-5{fill:#4299d7;}.cls-6{fill:#85c6f4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.49,139.56c50.92-21.69,102.67-2.51,137.77,39.26S504,150,543.07,191.69C569.73,220.15,557.52,293.32,521,325c-49.69,43.08-200.79,21.22-233.47,13.89-37.66-8.44-65.19-34.07-76.38-65.17C184.17,198.79,235,149.15,257.49,139.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M544.1,341.14c-25.49-1.64-112.19,1.13-138.56,2.21s-57-1.42-72.88-5.11-107.8.31-103.63,10.23,41,4.43,82.65,8.42,135.5-.5,156.66,0,40.56-1,67.83-3S558.87,342.09,544.1,341.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M311.06,327.59h-.13c-17,0-30.48-5-37.88-14-5.69-6.89-7.65-15.88-5.7-26,4.37-22.53,10.63-36.16,10.9-36.73l.83-1.78h63.83l.83,1.78c.26.57,6.53,14.2,10.89,36.73,2,10.12,0,19.11-5.69,26-7.41,9-20.86,13.93-37.88,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M343.48,237.53c-3.11-6.8-8-17.22-13.32-27.51-16.62-32.2-23.08-36.14-27.56-35.55h0c-4.47.64-9.63,6.17-17,41.66-2.34,11.34-4.25,22.69-5.41,30.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291.21,218.58c6.73-32.93,11.26-37.51,12.19-38.12,1.07.34,6.66,3.53,22,33.43,3.49,6.8,6.77,13.61,9.45,19.31l-47.54,6.52C288.35,233.51,289.69,226.07,291.21,218.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.11,227.86c-2.79-3.85-6.05-7.57-7.51-8.59a33.75,33.75,0,0,0-3.53,6.09c-.64,1.34-1.3,2.79-1.91,4.26-1-1.25-2-2.47-3-3.59a33.2,33.2,0,0,0-5-4.91c-1.13,1.37-3.28,5.83-4.92,10.29L293.31,230c4.68-12.72,7.24-13.07,8.21-13.2.69-.1,2.51-.34,7.59,5.15,3.41-6.66,5.23-6.91,5.92-7,1-.14,3.52-.49,11.45,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.07,255.28a180.35,180.35,0,0,0-9.67,33.52c-1.62,8.38-.14,15.41,4.4,20.91,6.22,7.54,18,11.7,33.19,11.72s27-4.18,33.2-11.72c4.54-5.5,6-12.53,4.4-20.91a180.35,180.35,0,0,0-9.67-33.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.47,281.53h0a1.17,1.17,0,0,1-1.15-1.17c.16-21.93,21.1-23.24,21.31-23.25a1.16,1.16,0,0,1,.12,2.31h0c-.78,0-19,1.23-19.12,21A1.15,1.15,0,0,1,258.47,281.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.39,262.5a1.16,1.16,0,0,1-.2-2.3h0c.61-.1,14.94-2.84,16.76-22.06a1.15,1.15,0,0,1,2.3.21c-2,21-18.5,24.1-18.67,24.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M290.61,348.35a1.15,1.15,0,0,1-.41-2.23c2.24-.85,2.1-11.9.57-21.69a1.15,1.15,0,0,1,2.28-.36c.81,5.19,3.07,22.27-2,24.21A1.18,1.18,0,0,1,290.61,348.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.44,348.35a1.18,1.18,0,0,1-.41-.07c-5.1-1.94-2.84-19-2-24.21a1.15,1.15,0,1,1,2.28.36c-1.53,9.79-1.67,20.84.57,21.69a1.15,1.15,0,0,1-.41,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M488.61,214.62c-.3-23.27-6.18-36.62-17.49-39.68s-23,5.58-34.61,25.66a196,196,0,0,0-11.8,24.71c-.63,1.59-1.11,2.85-1.41,3.68l-.44,1.18L486,247.22l.2-1.27c.14-.87.34-2.2.57-3.91A197.38,197.38,0,0,0,488.61,214.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M480.87,239.41,431.13,226a182,182,0,0,1,10.77-22.31c6.9-11.91,17.28-25.52,27.6-22.73s12.72,19.87,12.9,33.71A185.47,185.47,0,0,1,480.87,239.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M454.24,329h-.12c-17,0-30.48-5-37.89-14-5.68-6.88-7.65-15.87-5.69-26,4.36-22.54,10.63-36.17,10.89-36.74l.83-1.78H486.1l.82,1.78c.27.57,6.54,14.2,10.9,36.74,2,10.12,0,19.11-5.69,26-7.41,9-20.86,13.94-37.89,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.26,256.68a179.73,179.73,0,0,0-9.67,33.53c-1.62,8.37-.14,15.4,4.39,20.9,6.23,7.55,18,11.71,33.2,11.72s27-4.17,33.2-11.72c4.53-5.5,6-12.53,4.39-20.9a179.73,179.73,0,0,0-9.67-33.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M401.65,238.49h0a1.16,1.16,0,0,0-1.15,1.17c.15,21.94,21.09,23.24,21.31,23.25a1.17,1.17,0,0,0,1.21-1.09,1.15,1.15,0,0,0-1.1-1.21h0c-.77-.05-19-1.24-19.11-21A1.17,1.17,0,0,0,401.65,238.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M489.57,263.9a1.15,1.15,0,0,1-.19-2.29h0c.61-.11,14.94-2.84,16.75-22.07a1.16,1.16,0,1,1,2.3.22c-2,21-18.49,24.1-18.66,24.12A.68.68,0,0,1,489.57,263.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M433.8,349.76a1.16,1.16,0,0,1-.41-2.24c2.23-.85,2.1-11.9.57-21.68a1.15,1.15,0,0,1,2.28-.36c.81,5.19,3.07,22.27-2,24.2A1.24,1.24,0,0,1,433.8,349.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M470.63,349.76a1.15,1.15,0,0,1-.41-.08c-5.1-1.93-2.85-19-2-24.2a1.15,1.15,0,0,1,2.28.36c-1.53,9.78-1.67,20.83.57,21.68a1.16,1.16,0,0,1-.41,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M475,224.84a10.37,10.37,0,0,0-15.76-2.74,10.38,10.38,0,0,0-19.84.66,1.53,1.53,0,0,0-.07.36l0,.27,3.78,1,.11-.24a2,2,0,0,0,.13-.34,6.31,6.31,0,1,1,12.17,3.31,2,2,0,0,0,0,.34l0,.27,4.25,1.15.11-.25a1.66,1.66,0,0,0,.12-.31,6.31,6.31,0,0,1,12.18,3.31,1.7,1.7,0,0,0-.06.31l0,.28,3.53.95.28.05.11-.25a1.25,1.25,0,0,0,.1-.27A10.29,10.29,0,0,0,475,224.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 488.44,
    y: 146.1,
    width: 71,
    height: 36.44,
    rx: 18.22,
    transform: "translate(1047.87 328.65) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "539.51 178.32 517.91 197.47 522.63 177.72 539.51 178.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.86,
    y: 140.1,
    width: 70.58,
    height: 36.23,
    rx: 18.11,
    transform: "translate(508.29 316.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "266.95 171.34 273.82 191.95 253.83 171.34 266.95 171.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.72,159.6a3.54,3.54,0,1,0,3.54-3.3A3.42,3.42,0,0,0,268.72,159.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.65,159.6a3.54,3.54,0,1,0,3.53-3.3A3.42,3.42,0,0,0,250.65,159.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.58,159.6a3.54,3.54,0,1,0,3.53-3.3A3.42,3.42,0,0,0,232.58,159.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsTalking);
export default __webpack_public_path__ + "static/media/friends-talking.59fb0c990db38b4241f8be5a7821def7.svg";
export { ForwardRef as ReactComponent };